module.exports = __webpack_public_path__ + "static/img/activity_bj.19731dc0.png";